// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as PervasivesU from "rescript/lib/es6/pervasivesU.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";
import * as Menus$GameDataCore from "../Menus.res.mjs";

function requireChild(parent, selector, label) {
  var found = parent.querySelector(selector);
  if (!(found == null) && DomEl$GameDataCore.isHtmlElement(found)) {
    return found;
  }
  return PervasivesU.failwith(label + " element not found for popover matching " + selector);
}

function mounted() {
  var self = this ;
  var container = self.el;
  var popoverId = container.id;
  var trigger = requireChild(container, "#" + popoverId + "-trigger", "Trigger");
  var menu = requireChild(container, "#" + popoverId + "-menu", "Menu");
  var usePortal = Caml_obj.notequal(Caml_option.nullable_to_opt(container.getAttribute("data-popover-portal")), "false");
  var portalId = popoverId + "-menu-portal";
  var menuSelector = "#" + popoverId + "-menu";
  var state = {
    menu: menu,
    width: "",
    top: "",
    left: "",
    visible: false,
    closeTimer: undefined
  };
  if (usePortal) {
    document.body.appendChild(state.menu);
    state.menu.id = portalId;
    trigger.setAttribute("aria-controls", portalId);
  } else {
    trigger.setAttribute("aria-controls", popoverId + "-menu");
  }
  var updateVisibility = function () {
    if (state.visible) {
      return DomEl$GameDataCore.removeClass(state.menu, "hidden");
    } else {
      return DomEl$GameDataCore.addClass(state.menu, "hidden");
    }
  };
  var updateSize = function () {
    state.menu.style.minWidth = state.width;
  };
  var updatePosition = function () {
    var style = state.menu.style;
    style.top = state.top;
    style.left = state.left;
  };
  var setMenuOffsets = function () {
    var offsets = Menus$GameDataCore.getMenuOffsets(container, trigger, state.menu, (function (width) {
            state.width = width;
            updateSize();
          }));
    state.top = Menus$GameDataCore.orEmpty(offsets.top);
    state.left = Menus$GameDataCore.orEmpty(offsets.left);
    updatePosition();
  };
  var close = function () {
    state.visible = false;
    updateVisibility();
  };
  var handleFocusout = function ($$event) {
    var related = $$event.relatedTarget;
    if (!(related == null) && !(DomEl$GameDataCore.isHtmlElement(related) && (container.contains(related) || state.menu.contains(related)))) {
      return close();
    }
    
  };
  var handleKeydown = function ($$event) {
    if ($$event.key !== "Escape") {
      return ;
    }
    close();
    var active = document.activeElement;
    if (!(active == null) && container.contains(active)) {
      DomEl$GameDataCore.addClass(document.body, "tabbing");
      trigger.focus();
      return ;
    }
    
  };
  var handleWindowScroll = function ($$event) {
    var target = $$event.target;
    if (!(target == null) && DomEl$GameDataCore.isNode(target) && state.menu.contains(target)) {
      return ;
    } else {
      return setMenuOffsets();
    }
  };
  var handleClick = function (_event) {
    state.visible = !state.visible;
    updateVisibility();
    setMenuOffsets();
  };
  var handleClickOutside = function ($$event) {
    var target = $$event.target;
    if (!(target == null) && DomEl$GameDataCore.isNode(target) && (container.contains(target) || state.menu.contains(target))) {
      return ;
    } else {
      close();
      return setMenuOffsets();
    }
  };
  var dismissTargetFor = function (node) {
    var link = node.closest("a[href]");
    if (link == null) {
      return Caml_option.nullable_to_opt(node.closest("[role=\"menuitem\"]"));
    } else {
      return Caml_option.some(link);
    }
  };
  var handleMenuInteraction = function ($$event) {
    var target = $$event.target;
    var clicked = !(target == null) && DomEl$GameDataCore.isNode(target) && state.menu.contains(target) ? (
        DomEl$GameDataCore.isHtmlElement(target) ? Caml_option.some(target) : Caml_option.nullable_to_opt(target.parentElement)
      ) : undefined;
    var dismissTarget;
    if (clicked !== undefined) {
      var node = Caml_option.valFromOption(clicked);
      dismissTarget = DomEl$GameDataCore.isHtmlElement(node) ? dismissTargetFor(node) : undefined;
    } else {
      dismissTarget = undefined;
    }
    if (dismissTarget === undefined) {
      return ;
    }
    if (!state.menu.contains(Caml_option.valFromOption(dismissTarget))) {
      return ;
    }
    var timer = state.closeTimer;
    if (timer !== undefined) {
      clearTimeout(Caml_option.valFromOption(timer));
    }
    state.closeTimer = Caml_option.some(setTimeout((function () {
                state.closeTimer = undefined;
                if (container.isConnected && state.menu.isConnected) {
                  return close();
                }
                
              }), 0));
  };
  var attachMenuInteraction = function () {
    state.menu.addEventListener("click", handleMenuInteraction, {
          passive: true
        });
  };
  var detachMenuInteraction = function () {
    state.menu.removeEventListener("click", handleMenuInteraction);
  };
  attachMenuInteraction();
  var mutationObserver = new MutationObserver((function () {
          var relocated = container.querySelector(menuSelector);
          if (!(relocated == null) && DomEl$GameDataCore.isHtmlElement(relocated)) {
            if (state.menu !== relocated) {
              detachMenuInteraction();
              if (usePortal) {
                state.menu.remove();
                document.body.appendChild(relocated);
                relocated.id = portalId;
                trigger.setAttribute("aria-controls", portalId);
              } else {
                trigger.setAttribute("aria-controls", popoverId + "-menu");
              }
              state.menu = relocated;
              attachMenuInteraction();
            }
            updateVisibility();
            updateSize();
            return updatePosition();
          } else {
            return updatePosition();
          }
        }));
  mutationObserver.observe(container, {
        childList: true,
        subtree: true
      });
  var resizeObserver = new ResizeObserver(setMenuOffsets);
  resizeObserver.observe(trigger);
  var handleReposition = function (_event) {
    setMenuOffsets();
  };
  container.addEventListener("focusout", handleFocusout, {
        passive: false
      });
  trigger.addEventListener("click", handleClick, {
        passive: false
      });
  container.addEventListener("keydown", handleKeydown, {
        passive: false
      });
  container.addEventListener("keypress", handleKeydown, {
        passive: false
      });
  window.addEventListener("scroll", handleWindowScroll, {
        capture: true,
        passive: false
      });
  window.addEventListener("resize", handleReposition, {
        passive: false
      });
  window.addEventListener("click", handleClickOutside, {
        passive: false
      });
  var teardown = function () {
    var timer = state.closeTimer;
    if (timer !== undefined) {
      clearTimeout(Caml_option.valFromOption(timer));
      state.closeTimer = undefined;
    }
    mutationObserver.disconnect();
    resizeObserver.unobserve(trigger);
    resizeObserver.disconnect();
    detachMenuInteraction();
    container.removeEventListener("focusout", handleFocusout);
    trigger.removeEventListener("click", handleClick);
    container.removeEventListener("keydown", handleKeydown);
    container.removeEventListener("keypress", handleKeydown);
    window.removeEventListener("scroll", handleWindowScroll, true);
    window.removeEventListener("resize", handleReposition);
    window.removeEventListener("click", handleClickOutside);
    if (state.menu.isConnected) {
      state.menu.remove();
      return ;
    }
    
  };
  self._popoverHandlers = {
    updateVisibility: updateVisibility,
    updateSize: updateSize,
    updatePosition: updatePosition,
    teardown: teardown
  };
}

function updated() {
  var self = this ;
  var handlers = self._popoverHandlers;
  handlers.updateVisibility();
  handlers.updateSize();
  handlers.updatePosition();
}

function destroyed() {
  var self = this ;
  self._popoverHandlers.teardown();
}

var popover = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

export {
  requireChild ,
  mounted ,
  updated ,
  destroyed ,
  popover ,
}
/* mounted Not a pure module */
